import React, { createContext, useContext, useState } from 'react';
import { fetchData, fetchPostData } from '@/Components/hooks/Api';
import { Comman_changeArrayFormat, sixColArray, threeColArray } from '@/Components/Common/ChangeArrayFormat';

const ArrestContext = createContext();

export const ArrestProvider = ({ children }) => {
  const [arrestData, setArrestData] = useState([]);
  const [arrestFilterData, setArrestFilterData] = useState([]);
  const [arrestChargeData, setArrestChargeData] = useState([]);
  const [policeForceDrpData, setPoliceForceDrpData] = useState([]);
  const [arresteeDrpData, setArresteeDrpData] = useState([]);
  const [EditArrestStatus, setEditArrestStatus] = useState();
  const [arrestSearch, setarrestSearch] = useState([]);
  const [ArresteName, setArrestName] = useState(false);
  const [ArrestChargeStatus, setArrestChargeStatus] = useState('');
  const [ArresteeID, setArresteeID] = useState([]);
  const [activeArrest, setActiveArrest] = useState(null);
  const [tabCountArrest, setTabCountArrest] = useState([]);
  const [warrantChargeData, setWarrantChargeData] = useState();

  const get_Data_Arrest = (IncidentID, MstPage, loginPinID) => {
    const val = MstPage === 'MST-Arrest-Dash'
      ? { IncidentID: '0', PINID: loginPinID }
      : { IncidentID, PINID: loginPinID };
    fetchPostData('Arrest/GetData_Arrest', val).then((res) => {
      setArrestData(res || []);
      setArrestFilterData(res || []);
    });
  };

  const get_Arrestee_Drp_Data = (MstPage, MasterNameID, IncidentID) => {
    const val = MstPage === 'MST-Arrest-Dash'
      ? { IncidentID: '0', MasterNameID }
      : { MasterNameID: '0', IncidentID };
    fetchPostData('Arrest/GetDataDropDown_Arrestee', val).then((data) => {
      if (data) {
        setArresteeDrpData(
          sixColArray(
            data,
            'NameID',
            'Arrestee_Name',
            'LastName',
            'DateOfBirth',
            'Gendre_Description',
            'Race_Description',
            'NameID',
            'MasterNameID'
          )
        );
        setArresteeID(Comman_changeArrayFormat(data, 'NameID', 'Arrestee_Name'));
      } else {
        setArresteeDrpData([]);
        setArresteeID([]);
      }
    });
  };

  const get_Police_Force = () => {
    fetchData('DropDown/GetDataDropDown_RightsGiven').then((data) => {
      setPoliceForceDrpData(data ? threeColArray(data, 'RightGivenID', 'Description', 'Code') : []);
    });
  };

  const get_Data_Arrest_Charge = (ArrestID, DecEIncID) => {
    fetchPostData('ArrestCharge/GetData_ArrestCharge', { ArrestID, IncidentID: DecEIncID }).then((res) => {
      setArrestChargeData(res || []);
    });
  };

  const get_Data_Warrant_Charge = (WarrantID) => {
    fetchPostData('ArrestCharge/GetData_ArrestChargeWarrant', { WarrantID }).then((res) => {
      setWarrantChargeData(res || []);
    });
  };

  const get_OffenseName_Data = (DecNameID, status) => {
    fetchPostData('NameOffense/GetData_NameOffense', { NameID: DecNameID, IsIncidentOffense: status }).then((res) => {
      setArrestChargeData(res || []);
    });
  };

  const get_Arrest_Count = (ArrestID) => {
    fetchPostData('HomeApi/GetData_ArrestCount', { ArrestID }).then((res) => {
      setTabCountArrest(res?.[0] || []);
    });
  };

  const get_ArrestCharge_Count = (ChargeID) => {
    fetchPostData('ArrestCharge/GetData_ArrestChargeCount', { ChargeID }).then((res) => {
      setTabCountArrest(res?.[0] || []);
    });
  };

  return (
    <ArrestContext.Provider
      value={{
        arrestData,
        setArrestData,
        arrestFilterData,
        setArrestFilterData,
        arrestChargeData,
        setArrestChargeData,
        policeForceDrpData,
        arresteeDrpData,
        setArresteeDrpData,
        EditArrestStatus,
        setEditArrestStatus,
        arrestSearch,
        setarrestSearch,
        ArresteName,
        setArrestName,
        ArrestChargeStatus,
        setArrestChargeStatus,
        ArresteeID,
        setArresteeID,
        activeArrest,
        setActiveArrest,
        tabCountArrest,
        setTabCountArrest,
        warrantChargeData,
        get_Data_Arrest,
        get_Arrestee_Drp_Data,
        get_Police_Force,
        get_Data_Arrest_Charge,
        get_Data_Warrant_Charge,
        get_OffenseName_Data,
        get_Arrest_Count,
        get_ArrestCharge_Count,
      }}
    >
      {children}
    </ArrestContext.Provider>
  );
};

export const useArrest = () => {
  const context = useContext(ArrestContext);
  if (!context) throw new Error('useArrest must be used within ArrestProvider');
  return context;
};

export default ArrestContext;
